import { SvgIcon, SvgIconProps } from '@material-ui/core'

type PinIconProps = SvgIconProps & {
    outlineOnly?: boolean
}

export default function PinIcon({ outlineOnly, ...rest }: PinIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...rest}>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill={outlineOnly ? 'none' : 'currentColor'}
                    stroke={!outlineOnly ? 'none' : 'currentColor'}
                    strokeWidth={1}
                    d="M15.1139 3.20872L15.2079 3.29172L20.7079 8.79173C20.8764 8.9612 20.9787 9.18545 20.9962 9.42385C21.0137 9.66225 20.9452 9.89903 20.8031 10.0913C20.661 10.2835 20.4548 10.4185 20.2218 10.4718C19.8104 10.5658 19.3295 10.5851 19.031 10.8834L17.0817 12.8321C16.6066 13.307 16.2388 13.8781 16.003 14.5071L14.9369 17.3497C14.8994 17.4499 14.846 17.5434 14.7789 17.6267L14.7089 17.7067L13.2089 19.2067C13.0365 19.3788 12.8074 19.482 12.5644 19.4971C12.3213 19.5122 12.0811 19.4381 11.8889 19.2887L11.7939 19.2057L9.00086 16.4137L5.20786 20.2057C5.0279 20.3851 4.78643 20.4892 4.53248 20.497C4.27853 20.5047 4.03115 20.4155 3.84058 20.2475C3.65002 20.0794 3.53056 19.8452 3.50646 19.5922C3.48237 19.3393 3.55545 19.0867 3.71086 18.8857L3.79386 18.7917L7.58586 14.9987L4.79386 12.2057C4.62168 12.0335 4.51825 11.8044 4.50297 11.5614C4.48769 11.3184 4.56161 11.0781 4.71086 10.8857L4.79386 10.7917L6.29386 9.29173C6.36931 9.216 6.45642 9.15287 6.55186 9.10472L6.64986 9.06273L9.49821 7.99347C10.1228 7.75902 10.6899 7.39372 11.1617 6.92209L13.1352 4.94928C13.4212 4.66331 13.4403 4.20445 13.5167 3.80723C13.56 3.58209 13.6793 3.37866 13.8547 3.23102C14.0301 3.08338 14.2509 3.0005 14.4802 2.99626C14.7094 2.99202 14.9331 3.06768 15.1139 3.20872Z"
                />
            </g>
        </SvgIcon>
    )
}
